// extracted by mini-css-extract-plugin
export default {"landingContainer":"styles_landingContainer__Wnra6"};